const LanguageCodeEnum = {
  ja: {
    value: 0, // Not Id
    text: '和文',
    language: '日本語',
    color: 'green'
  },
  en: {
    value: 1,
    text: '英文',
    language: '英語',
    color: 'blue'
  }
};

export default LanguageCodeEnum;

function getLanguageCodeList() {
  let languageCodeList = [];
  for (let key in LanguageCodeEnum) {
    let enumData = LanguageCodeEnum[key];
    enumData.languageCodeKey = key;
    languageCodeList.push(enumData);
  }
  return languageCodeList;
}

export const LanguageCodeList = getLanguageCodeList();



// WEBPACK FOOTER //
// ./src/constants/category/language_code.js